// extracted by mini-css-extract-plugin
export default {"cardsContent":"Classroom_cardsContent__NwCYz","fondo":"Classroom_fondo__jhXfF","topDiv":"Classroom_topDiv__1kZ8d","agregarBoton":"Classroom_agregarBoton__u0Jtd"};